import { ComponentProps } from "react";
import { Outlet } from "react-router-dom";
import styled from "@emotion/styled";
import { RegulationsProvider } from "../providers/RegulationsProvider";

const Main = styled.main`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const RegulationDocumentLayout = styled(
  (props: ComponentProps<"div">) => (
    <RegulationsProvider>
      <div {...props}>
        <Main>
          <Outlet />
        </Main>
      </div>
    </RegulationsProvider>
  )
)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.background.default};
`;
